const palette = {
  white: '#ffffff',
  red: '#db1604',
  black: '#000000',
  lightGray: '#d6d6e3',
  darkGray: '#535461',
};

export const colors = {
  appBackground: palette.white,
  primary: palette.red,
  black: palette.black,
  white: palette.white,
  lightTitle: palette.lightGray,
  darkTitle: palette.darkGray,
};
